fx.ns("common.popups", class AddPaginationPopup extends fx.components.Popup{
    
    constructor()
    {
        super();
        this.contentWidth = 260;
        this.contentHeight = 260;
        this.closeOnClickBehind = true;
        this.options = {modal : false, top:"center", left : "center", leftArrow : true}
    }


    create()
    {
        super.create();
        this.okButton = new fx.components.Button({label : fx.text("Ok")});
        let text1 = new fx.components.Text({text: fx.text("J'ai numéroté vos pages"), className: "text1"});
        let text2 = new fx.components.Text({text: fx.text("Cliquez pour éditer la taille, la police et la couleur"), className: "text2"});
        let person = new shared.component.Person(fx.get("assets").personSure );
        let vbox = new fx.components.VBox();
        vbox.addChild(person , {width:120, height : 120, left : "center"});
        vbox.addChild(text1, {width :"100%"});
        vbox.addChild(text2, {width :"100%"});
        vbox.addChild(this.okButton, {width :125});
        this.addChild(vbox, {top: 0, width:"100%"});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
        this.on("ENTER", this.close, fx.keyboard);

    }

});